class PropertiesMap {
    constructor(el = null) {
        this.el = el;

        if(this.el) {
            if(typeof baf_properties !== 'undefined' && Array.isArray(baf_properties) && baf_properties.length) {
                this.init();
                this.bindEvents();
                this.waitForGMapLibrary();
            }
            else {
                this.el.style.display = 'none';
            }
        }
    }

    init() {
        this.map = null;
        this.markers = {};
        this.infoWindow = null;
        this.initialized = false;
    }

    bindEvents() {
        this.onFocusMarkerFn = this.onFocusMarker.bind(this);
        this.onDefocusMarkerFn = this.onDefocusMarker.bind(this);

        document.addEventListener('properties-map:focusMarker', this.onFocusMarkerFn);
        document.addEventListener('properties-map:defocusMarker', this.onDefocusMarkerFn);
    }

    waitForGMapLibrary() {
        if(typeof google !== 'undefined' && typeof google?.maps?.places?.Autocomplete !== 'undefined' && typeof google?.maps?.DistanceMatrixService !== 'undefined') {
            this.onGMapLibraryLoaded();
        }
        else {
            this.onGMapLibraryLoadedFn = this.onGMapLibraryLoaded.bind(this);
            document.addEventListener('gmap-library:loaded', this.onGMapLibraryLoadedFn);
        }
    }

    onGMapLibraryLoaded() {
        if(this.initialized) {
            return;
        }
        if(this?.onGMapLibraryLoadedFn) {
            document.removeEventListener('gmap-library:loaded', this.onGMapLibraryLoadedFn);
        }

        this.initialized = true;

        this.initMap();
    }

    initMap() {
        this.map = new google.maps.Map(this.el, {
            center: {lat: 0, lng: 0},
            zoom: 10,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false
        });
        this.infoWindow = new google.maps.InfoWindow();

        const bounds = new google.maps.LatLngBounds();

        for(const poi of baf_properties) {
            if(poi?.lat && poi?.lng) {
                const lat = parseFloat(poi.lat);
                const lng = parseFloat(poi.lng);
                
                if(!isNaN(lat) && !isNaN(lng)) {
                    const poiPos = new google.maps.LatLng(lat, lng);
                    const marker = new google.maps.Marker({
                        position: poiPos,
                        // icon: '/wp-content/',
                        map: this.map
                    });

                    // Extend map bound to be able to view the marker on the map
                    bounds.extend(poiPos);

                    marker.addListener('click', () => {
                        const content = `
                            <div class="infowindow-content" style="width:270px;">
                                ${poi.picture}
                                <div class="heading heading--h3">${poi.title}</div>
                                <p>${poi.bedroomCount}&nbsp;chambre(s) - ${poi.floorArea}&nbsp;m<sup>2</sup></p>
                                <p><strong>${poi.salePrice}&nbsp;€</strong></p>
                                ${poi.link ? `<p><a href="${poi.link}" target="_blank" rel="noopener noreferrer">Voir le bien</a></p>` : ``}
                            </div>
                        `;

                        if(this.infoWindow) {
                            this.infoWindow.close();
                        }

                        this.infoWindow.setContent(content);
                        this.infoWindow.open({
                            anchor: marker,
                            map: this.map,
                            shouldFocus: false,
                        });
                    });

                    this.markers[poi.id] = marker;
                }
                else {
                    console.warn(`Coordonnées GPS invalides pour ${poi}`);
                }
            }
        }

        // Update map zoom according to calculated bounds
        this.map.fitBounds(bounds);
    }

    onFocusMarker(e) {
        if(!this.initialized) {
            return;
        }
        const {id} = e.detail;
        console.log('onFocusMarker', id, this);

        for(const propertyId in this.markers) {
            const marker = this.markers[propertyId];
            console.log(propertyId, id);
            if(propertyId == id) {
                marker.setAnimation(google.maps.Animation.BOUNCE);
            } 
            else {
                marker.setAnimation(null);
            }
        }
    }

    onDefocusMarker(e) {
        if(!this.initialized) {
            return;
        }
        const {id} = e.detail;
        console.log('onDefocusMarker', id, this);

        for(const propertyId in this.markers) {
            const marker = this.markers[propertyId];
            console.log(propertyId, id);
            if(propertyId == id) {
                marker.setAnimation(null);
            }
        }
    }
}

export default PropertiesMap;

new PropertiesMap(document.querySelector('.properties-map'));